class ComboModel {
	constructor(combo) {
		const { label, value } = combo;
		this.label = `${value} : ${label}`;
		this.value = value;
	}
}

export default ComboModel;
